import { call, put, all, takeLatest } from 'redux-saga/effects';
import { IGetFilter, IGetForms, types } from './types';
import { getProjectGuide as getProjectGuideTrigger, setProjectGuide as setProjectGuideTrigger } from '../project';
import {
    getFiltersFail,
    getFiltersSuccess,
    getSystemFormsFail,
    getSystemFormsSuccess,
    setProjectGuide as setProjectGuideAction,
} from './action';
import { api } from '../../configurations/api';
import { filterUrl, formsUrl } from '../../configurations/api/url';
import { httpRequest } from '../types';
import { getNotUniqueCacheByKey, isUseCacheEnabled } from '../cache/saga';
import { CACHE_TYPE, NotUniqueCacheValue } from '../cache/types';
import { setCache } from '../cache/action';

function* getProjectGuide(): Generator<any, any, any> {
    try {
        const response = yield call(getProjectGuideTrigger);
        yield put(setProjectGuideAction(!!response));
    } catch (error) {
        console.log(error);
    }
}

function* setProjectGuide() {
    try {
        yield call(setProjectGuideTrigger);
        yield put(setProjectGuideAction(true));
    } catch (error) {
        console.log(error);
    }
}

function* getFilter({ payload }: { payload: IGetFilter }): Generator<any, any, any> {
    const query = new URLSearchParams();
    if (payload.coll_type) query.append('coll_type', payload.coll_type);
    let initialResult: any = null;
    const defaultUseCache = yield* isUseCacheEnabled();
    const key = payload.coll_type === 'audition' ? CACHE_TYPE.AUDITION_FILTER : CACHE_TYPE.EVENT_FILTER;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(key, query.toString());

    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (defaultUseCache && initialResult) {
        yield put(getFiltersSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${filterUrl}?${query.toString()}`, httpRequest.GET, {});
            const { data } = response.data;
            yield put(getFiltersSuccess(data[0]));
            yield put(
                setCache({
                    key: query.toString(),
                    value: data,
                    type: key,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            yield put(getFiltersFail(error));
        }
    }
}

function* getSystemForms({ payload }: { payload: IGetForms }): Generator<any, any, any> {
    const query = new URLSearchParams();
    if (payload.tag) query.append('tag', payload.tag);
    let initialResult: any = null;
    const defaultUseCache = yield* isUseCacheEnabled();
    const key = payload.tag === 'system' ? CACHE_TYPE.SYSTEM_FORM : CACHE_TYPE.UNIQUE_FORM;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(key, query.toString());

    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (defaultUseCache && initialResult) {
        yield put(getSystemFormsSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${formsUrl}?${query.toString()}`, httpRequest.GET, {});
            const { data } = response.data;
            yield put(getSystemFormsSuccess(data));
            yield put(
                setCache({
                    key: query.toString(),
                    value: data,
                    type: key,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            yield put(getSystemFormsFail(error));
        }
    }
}

function* projectGuideWatcher() {
    yield takeLatest(types.GET_PROJECT_GUIDE, getProjectGuide);
}
function* setProjectGuideWatcher() {
    yield takeLatest(types.SET_PROJECT_GUIDE, setProjectGuide);
}

function* getFilterWatcher() {
    yield takeLatest<any>(types.GET_FILTERS, getFilter);
}

function* getFormsWatcher() {
    yield takeLatest<any>(types.GET_SYSTEM_FORMS, getSystemForms);
}

export default function* appConfiguratorSaga() {
    yield all([projectGuideWatcher(), setProjectGuideWatcher(), getFilterWatcher(), getFormsWatcher()]);
}
